import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Line} from 'react-chartjs-2';
import {Button} from '../../../../lib/components/Button.component';
import {Select} from '../../../../lib/components/Select.component';
import {Table} from '../../../../lib/components/Table.component';
import {fget, fpost} from '../../../../lib/fetch';
import {configDouble, dataDouble} from '../../../map-dialog/components/DoubleChart';
import {AreaEntity} from '../../dto/area/area.entity';
import {DeviceEntity} from '../../dto/device/device.entity';
import {DeviceRecord} from '../../dto/device/deviceRecord';
import {ResponseDocument, ResponseGetDocument, ResponseListDocuments} from '../../dto/response';
// @ts-ignore
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './raw.css';
// @ts-ignore
import {CSVLink} from 'react-csv';
import {useParams} from 'react-router-dom';
import {Pagination} from 'src/lib/components/Pagination.component';
import {toasting} from 'src/lib/components/Toast.component';
import {dataVelocity} from '../../../map-dialog/components/VelocityConfig';
import {data as dataFlowRate} from "../../../map-dialog/components/FlowRateConfig";
import {dataWater} from "../../../map-dialog/components/WaterLevelConfig";
import {twMerge} from "tailwind-merge";
import {AiOutlineReload} from "react-icons/ai";
import { format } from 'date-fns';
import ja from 'date-fns/locale/ja';
import {option} from "../../interfaces/option";

export function RawPage() {
  const [record, setRecord] = useState<ResponseListDocuments<DeviceRecord>>();
  const headers = ['SID', 'CNT', 'RF', 'VOL', 'DIS', 'PUBLISH', 'WATER_LEVEL', 'VELOCITY', 'FLOW_RATE'];
  const [csvData, setCsvData] = useState<any[]>([]);
  const csvLinkRef = useRef<any>(null);
  const [isReloading, setIsReloading] = useState(false);
  const [active, setActive] = useState(4);
  const [selectedPointIndex, setSelectedPointIndex] = useState<number | null>(null);
  let date, firstDayCsv, lastDayCsv;
  date = new Date();
  firstDayCsv = new Date(date.getFullYear(), date.getMonth(), 1);
  lastDayCsv = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59);
  const [downloadCsvProcessing, setDownloadCsvProcessing] = useState(false);
  const [getRecordProcessing, setGetRecordProcessing] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const eSelectRegionName = useRef<HTMLSelectElement>(null);
  const eSelectDeviceName = useRef<HTMLSelectElement>(null);
  const [isRangeInvalid, setIsRangeInvalid] = useState(false);
  const [selectedAreaName, setSelectedAreaName] = useState('');
  const [selectedDeviceId, setSelectedDeviceId] = useState('');
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([firstDayCsv, lastDayCsv]);
  const [startDateCsv, endDateCsv] = dateRange;

  const [minVelocitySetting, setMinVelocitySetting] = useState<number | null>(null);
  const [maxVelocitySetting, setMaxVelocitySetting] = useState<number | null>(null);
  const [minWaterRateSetting, setMinWaterRateSetting] = useState<number | null>(null);
  const [maxWaterRateSetting, setMaxWaterRateSetting] = useState<number | null>(null);
  const [minWaterLevelSetting, setMinWaterLevelSetting] = useState<number | null>(null);
  const [maxWaterLevelSetting, setMaxWaterLevelSetting] = useState<number | null>(null);
  const handleMinMax = (e:any, inputCase:string) => {
    const normalizedValue = e.target.value === '' ? null : Number(e.target.value);
    switch (inputCase) {
      case 'minVelocitySetting':
        setMinVelocitySetting(normalizedValue);
        break;
      case 'maxVelocitySetting':
        setMaxVelocitySetting(normalizedValue);
        break;
      case 'minWaterRateSetting':
        setMinWaterRateSetting(normalizedValue);
        break;
      case 'maxWaterRateSetting':
        setMaxWaterRateSetting(normalizedValue);
        break;
      case 'minWaterLevelSetting':
        setMinWaterLevelSetting(normalizedValue);
        break;
      case 'maxWaterLevelSetting':
        setMaxWaterLevelSetting(normalizedValue);
        break;
    }
  };

  const option:option= {
    minVelocitySetting: minVelocitySetting,
    maxVelocitySetting: maxVelocitySetting,
    minWaterRateSetting: minWaterRateSetting,
    maxWaterRateSetting: maxWaterRateSetting,
    minWaterLevelSetting: minWaterLevelSetting,
    maxWaterLevelSetting: maxWaterLevelSetting,
  }

  const applyYAxisRanges = (
    flowRange: [number, number],
    waterLevelRange: [number, number],
    velocityRange: [number, number],
  ) => {
    const ranges = [flowRange, waterLevelRange, velocityRange];
    ranges.forEach(([automaticMin, automaticMax], axisIndex) => {
      configDouble.options.scales.yAxes[axisIndex].ticks.min = automaticMin;
      configDouble.options.scales.yAxes[axisIndex].ticks.max = automaticMax;
    });
  };

  const getFirstDayOfWeek = (date:Date) => {
    return date.getTime() - ((date.getDay() === 0 ? 6 : date.getDay() - 1)) * 24 * 60 * 60 * 1000
  }

  const getTimeWithZero = (time: number) => {
    return time < 10 ? '0' + time : time;
  }

  const { id } = useParams();
  const [data, setData] = useState<{
    deviceInit?: ResponseDocument<DeviceEntity>;
    areas?: ResponseListDocuments<AreaEntity>;
    devices?: ResponseListDocuments<DeviceEntity>;
  }>();

  const setChartLabelString = (action: number) => {
    let label = '';

    // convert to two digits
    let year = new Date().getFullYear();
    let month: number | string = new Date().getMonth() + 1;
    let hour = new Date().getHours();
    let day = new Date().getDate();
    let dow = new Date().getDay() - 1;
    let startDayOfWeekTimestamp = getFirstDayOfWeek(new Date());

    if (startDateCsv){
      year = startDateCsv.getFullYear();
      month = startDateCsv.getMonth() + 1;
      hour = startDateCsv.getHours();
      day = startDateCsv.getDate();
      dow = startDateCsv.getDay() - 1;
      startDayOfWeekTimestamp = getFirstDayOfWeek(startDateCsv);
    }
    month = month < 10 ? '0' + month.toString() : month;

    const endDayOfWeekTimestamp = startDayOfWeekTimestamp + 6 * 24 * 60 * 60 * 1000;
    const endDayOfWeek = new Date(endDayOfWeekTimestamp);
    const startDayOfWeek = new Date(startDayOfWeekTimestamp);
    const startDayOfWeekFull = `${startDayOfWeek.getFullYear()}/${getTimeWithZero(startDayOfWeek.getMonth() + 1)}/${getTimeWithZero(startDayOfWeek.getDate())}`
    const endDayOfWeekFull = `${endDayOfWeek.getFullYear()}/${getTimeWithZero(endDayOfWeek.getMonth() + 1)}/${getTimeWithZero(endDayOfWeek.getDate())}週`

    switch (action) {
      case 1:
        label = `${year}年`;
        break;
      case 2:
        label = `${year}/${month}月`;
        break;
      case 3:
        label = `
         ${startDayOfWeekFull} - ${endDayOfWeekFull}
        `;
        break;
      case 4:
        label = endDateCsv
          ? `${format(startDateCsv || new Date(), 'yyyy/MM/dd HH:mm')} - ${format(endDateCsv, 'yyyy/MM/dd HH:mm')}`
          : `${year}/${month}/${day}日`;
        break;
      case 5:
        label = endDateCsv
          ? `${format(startDateCsv || new Date(), 'yyyy/MM/dd HH:mm')} - ${format(endDateCsv, 'yyyy/MM/dd HH:mm')}`
          : `${year}/${month}/${day} ${hour}:00時`;
        break;
    }

    configDouble.options.scales.xAxes[0].scaleLabel.labelString = label;
  };

  const getHourInDay = (hour: number) => {
    const newHour = (hour + 9) % 24;
    return newHour >= 0 ? newHour : newHour + 24;
  }

  const getAdjustedValue = (min:number, max:number) => {
    if (!Number.isFinite(min) || !Number.isFinite(max)) return [0, 1];

    if (min === max) {
      const padding = Math.max(Math.abs(min) * 0.2, 0.1);
      return [min - padding, max + padding];
    }

    const range = max - min;
    const scalingFactor = 0.2;

    const adjustedMin = min - range * scalingFactor;
    const adjustedMax = max + range * scalingFactor;

    return [
      adjustedMin,
      adjustedMax,
    ];
  }

  const resetSettingMinMaxData = () => {
    setMinVelocitySetting(null);
    setMaxVelocitySetting(null);
    setMinWaterRateSetting(null);
    setMaxWaterRateSetting(null);
    setMinWaterLevelSetting(null);
    setMaxWaterLevelSetting(null);
  }

  const resetGraphData = (quantity:number) => {
    setSelectedPointIndex(null);
    dataDouble.datasets[0].data = Array.from({ length: quantity }, () => null);
    dataDouble.datasets[1].data = Array.from({ length: quantity }, () => null);
    dataDouble.datasets[2].data = Array.from({ length: quantity }, () => null);
  }

  const getYear = async (startDate: Date|null) => {
    // validate
    const deviceId = eSelectDeviceName?.current?.value;
    if (!deviceId) return;

    //set label
    dataDouble.labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // set start, end date
    const now = new Date();
    const start = startDate ? new Date(startDate.getFullYear(), 0, 1) : new Date(now.getFullYear(), 0, 1);
    const end = new Date(start.getFullYear(), 11, 31, 23, 59, 59);

    // get record
    const query = {
      query: {
        ExpressionAttributeValues: {
          ':id': { S: deviceId },
          ':timeStart': { S: start.getTime().toString() },
          ':timeEnd': { S: end.getTime().toString() },
        },
        KeyConditionExpression: 'DEVICE_ID = :id and CREATE_AT BETWEEN :timeStart and :timeEnd',
        TableName: 'DEVICE_RECORD_YEAR',
        ScanIndexForward: false,
      },
    };

    const data = await fpost<any>('api/device/record/query', {
      body: query,
    });
    const items = data[1].Items.reverse();

    resetGraphData(12)

    let maxWaterLevel = -Infinity;
    let maxFlowRate = -Infinity;
    let maxVelocity = -Infinity;
    let minWaterLevel = Infinity;
    let minFlowRate = Infinity;
    let minVelocity = Infinity;
    for (const item of items) {
      const month = new Date(parseInt(item.CREATE_AT?.S)).getMonth();
      if (item.WATER_LEVEL) {
        const waterLevel = item.WATER_LEVEL.S;
        dataDouble.datasets[1].data[month] = waterLevel;
        maxWaterLevel = Math.max(waterLevel, maxWaterLevel);
        minWaterLevel = Math.min(waterLevel, minWaterLevel);
      }
      if (item.FLOW_RATE) {
        const flowRate = item.FLOW_RATE.S;
        dataDouble.datasets[0].data[month] = flowRate;
        maxFlowRate = Math.max(flowRate, maxFlowRate);
        minFlowRate = Math.min(flowRate, minFlowRate);
      }
      if (item.VELOCITY) {
        const velocity = item.VELOCITY.S;
        dataDouble.datasets[2].data[month ] = velocity;
        dataVelocity.datasets[0].data[month] = velocity;

        maxVelocity = Math.max(maxVelocity, velocity);
        minVelocity = Math.min(minVelocity, velocity);
      }
    }

    const [adjustedMinWaterLevel, adjustedMaxWaterLevel] = getAdjustedValue(minWaterLevel, maxWaterLevel);
    const [adjustedMinFlowRate, adjustedMaxFlowRate] = getAdjustedValue(minFlowRate, maxFlowRate);
    const [adjustedMinVelocity, adjustedMaxVelocity] = getAdjustedValue(minVelocity, maxVelocity);

    if (option.minWaterRateSetting && option.maxWaterRateSetting) {
      configDouble.options.scales.yAxes[0].ticks.min = Math.floor(option.minWaterRateSetting);
      configDouble.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxWaterRateSetting);
    } else {
      configDouble.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinFlowRate);
      configDouble.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxFlowRate);
    }

    if (option.maxWaterLevelSetting && option.minWaterLevelSetting) {
      configDouble.options.scales.yAxes[1].ticks.min = Math.floor(option.minWaterLevelSetting);
      configDouble.options.scales.yAxes[1].ticks.max = Math.ceil(option.maxWaterLevelSetting);
    } else {
      configDouble.options.scales.yAxes[1].ticks.min = Math.floor(adjustedMinWaterLevel);
      configDouble.options.scales.yAxes[1].ticks.max = Math.ceil(adjustedMaxWaterLevel);
    }

    if(option.minVelocitySetting && option.maxVelocitySetting) {
      configDouble.options.scales.yAxes[2].ticks.min = Math.floor(option.minVelocitySetting);
      configDouble.options.scales.yAxes[2].ticks.max = Math.ceil(option.maxVelocitySetting);
    } else {
      configDouble.options.scales.yAxes[2].ticks.min = Math.floor(adjustedMinVelocity);
      configDouble.options.scales.yAxes[2].ticks.max = Math.ceil(adjustedMaxVelocity);
    }
    applyYAxisRanges(
      [adjustedMinFlowRate, adjustedMaxFlowRate],
      [adjustedMinWaterLevel, adjustedMaxWaterLevel],
      [adjustedMinVelocity, adjustedMaxVelocity],
    );
    setTrigger((current) => !current);
  };

  const getMonth = async (startDate:Date|null) => {
    // validate
    const deviceId = eSelectDeviceName?.current?.value;
    if (!deviceId) return;

    // set start end date
    const now = new Date();
    const startDay = startDate ? new Date(startDate.getFullYear(), startDate.getMonth(), 1) : new Date(now.getFullYear(), now.getMonth(), 1);
    const endDay = new Date(startDay.getFullYear(), startDay.getMonth() + 1, 0);
    endDay.setHours(23, 59, 59)

    // set label
    const daysInMonth = new Date(startDay.getFullYear(), startDay.getMonth() + 1, 0).getDate();
    dataDouble.labels = Array.from({length: daysInMonth}, (_, index) => (index + 1).toString());

    try {
      const query = {
        query: {
          ExpressionAttributeValues: {
            ':id': { S: deviceId },
            ':timeStart': { S: startDay.getTime().toString() },
            ':timeEnd': { S: endDay.getTime().toString() },
          },
          KeyConditionExpression: 'DEVICE_ID = :id and CREATE_AT BETWEEN :timeStart and :timeEnd',
          TableName: 'DEVICE_RECORD_MONTH',
          ScanIndexForward: false,
        },
      };
      const data = await fpost<any>('api/device/record/query', {
        body: query,
      });

      const items = data[1].Items.reverse();

      resetGraphData(daysInMonth)

      let maxWaterLevel = -Infinity;
      let maxFlowRate = -Infinity;
      let maxVelocity = -Infinity;
      let minWaterLevel = Infinity;
      let minFlowRate = Infinity;
      let minVelocity = Infinity;

      for (const item of items) {
        const dom = new Date(parseInt(item.CREATE_AT?.S)).getDate();
        if (item.WATER_LEVEL) {
          const waterLevel = item.WATER_LEVEL.S;
          dataDouble.datasets[1].data[dom - 1] = waterLevel;

          minWaterLevel = Math.min(waterLevel, minWaterLevel);
          maxWaterLevel = Math.max(waterLevel, maxWaterLevel);
        }
        if (item.FLOW_RATE) {
          const flowRate = item.FLOW_RATE.S;
          dataDouble.datasets[0].data[dom - 1] = flowRate;

          maxFlowRate = Math.max(flowRate, maxFlowRate);
          minFlowRate = Math.min(flowRate, minFlowRate);
        }
        if (item.VELOCITY) {
          const velocity = item.VELOCITY.S;
          dataDouble.datasets[2].data[dom - 1] = velocity;
          dataVelocity.datasets[0].data[dom - 1] = velocity;

          maxVelocity = Math.max(maxVelocity, velocity);
          minVelocity = Math.min(minVelocity, velocity);
        }
      }
      const [adjustedMinWaterLevel, adjustedMaxWaterLevel] = getAdjustedValue(minWaterLevel, maxWaterLevel);
      const [adjustedMinFlowRate, adjustedMaxFlowRate] = getAdjustedValue(minFlowRate, maxFlowRate);
      const [adjustedMinVelocity, adjustedMaxVelocity] = getAdjustedValue(minVelocity, maxVelocity);

      if (option.minWaterRateSetting && option.maxWaterRateSetting) {
        configDouble.options.scales.yAxes[0].ticks.min = Math.floor(option.minWaterRateSetting);
        configDouble.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxWaterRateSetting);
      } else {
        configDouble.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinFlowRate);
        configDouble.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxFlowRate);
      }

      if (option.maxWaterLevelSetting && option.minWaterLevelSetting) {
        configDouble.options.scales.yAxes[1].ticks.min = Math.floor(option.minWaterLevelSetting);
        configDouble.options.scales.yAxes[1].ticks.max = Math.ceil(option.maxWaterLevelSetting);
      } else {
        configDouble.options.scales.yAxes[1].ticks.min = Math.floor(adjustedMinWaterLevel);
        configDouble.options.scales.yAxes[1].ticks.max = Math.ceil(adjustedMaxWaterLevel);
      }

      if(option.minVelocitySetting && option.maxVelocitySetting) {
        configDouble.options.scales.yAxes[2].ticks.min = Math.floor(option.minVelocitySetting);
        configDouble.options.scales.yAxes[2].ticks.max = Math.ceil(option.maxVelocitySetting);
      } else {
        configDouble.options.scales.yAxes[2].ticks.min = Math.floor(adjustedMinVelocity);
        configDouble.options.scales.yAxes[2].ticks.max = Math.ceil(adjustedMaxVelocity);
      }
      applyYAxisRanges(
        [adjustedMinFlowRate, adjustedMaxFlowRate],
        [adjustedMinWaterLevel, adjustedMaxWaterLevel],
        [adjustedMinVelocity, adjustedMaxVelocity],
      );

    } catch (error) {
      toasting({ children: 'Start date and end date invalid!', containerProps: { className: 'border-red-600' } });
      console.error(error);
    }

    setTrigger((current) => !current);
  };

  const getWeek = async (startDate:Date|null) => {
    // validate
    const deviceId = eSelectDeviceName?.current?.value;
    if (!deviceId) return;

    // set start, end date
    const startDay = startDate ? new Date(startDate.getTime()) : new Date();
    startDay.setHours(0, 0, 0, 0);

    const firstDayOfWeek = getFirstDayOfWeek(startDay);
    const weekDays = ['月', '火', '水', '木', '金', '土', '日'];
    dataDouble.labels = weekDays.map((weekDay, index) => {
      const dateOfWeek = new Date(firstDayOfWeek + index * 24 * 60 * 60 * 1000);
      return `${format(dateOfWeek, 'MM/dd')}(${weekDay})`;
    });
    const lastDayOfWeek = new Date(firstDayOfWeek + 6 * 24 * 60 * 60 * 1000);
    lastDayOfWeek.setHours(23, 59, 59);

    try {
      // get records
      const query = {
        query: {
          ExpressionAttributeValues: {
            ':id': { S: deviceId },
            ':timeStart': { S: firstDayOfWeek.toString() },
            ':timeEnd': { S: lastDayOfWeek.getTime().toString() },
          },
          KeyConditionExpression: 'DEVICE_ID = :id and CREATE_AT BETWEEN :timeStart and :timeEnd',
          TableName: 'DEVICE_RECORD_MONTH',
          ScanIndexForward: false,
        },
      };
      const data = await fpost<any>('api/device/record/query', {
        body: query,
      });
      const items = data[1].Items.reverse();

      resetGraphData(7)

      let maxWaterLevel = -Infinity;
      let maxFlowRate = -Infinity;
      let maxVelocity = -Infinity;
      let minWaterLevel = Infinity;
      let minFlowRate = Infinity;
      let minVelocity = Infinity;
      for (const item of items) {
        const dow = new Date(parseInt(item.CREATE_AT.S)).getDay() == 0 ? 6 : new Date(parseInt(item.CREATE_AT.S)).getDay() - 1;

        if (item.WATER_LEVEL) {
          const waterLevel = item.WATER_LEVEL.S;
          dataDouble.datasets[1].data[dow] = waterLevel;

          minWaterLevel = Math.min(waterLevel, minWaterLevel);
          maxWaterLevel = Math.max(waterLevel, maxWaterLevel);
        }
        if (item.FLOW_RATE) {
          const flowRate = item.FLOW_RATE.S;
          dataDouble.datasets[0].data[dow] = flowRate;

          maxFlowRate = Math.max(flowRate, maxFlowRate);
          minFlowRate = Math.min(flowRate, minFlowRate);
        }
        if (item.VELOCITY) {
          const velocity = item.VELOCITY.S;
          dataDouble.datasets[2].data[dow] = velocity;
          dataVelocity.datasets[0].data[dow] = velocity;

          maxVelocity = Math.max(maxVelocity, velocity);
          minVelocity = Math.min(minVelocity, velocity);
        }
      }

      const [adjustedMinWaterLevel, adjustedMaxWaterLevel] = getAdjustedValue(minWaterLevel, maxWaterLevel);
      const [adjustedMinFlowRate, adjustedMaxFlowRate] = getAdjustedValue(minFlowRate, maxFlowRate);
      const [adjustedMinVelocity, adjustedMaxVelocity] = getAdjustedValue(minVelocity, maxVelocity);

      if (option.minWaterRateSetting && option.maxWaterRateSetting) {
        configDouble.options.scales.yAxes[0].ticks.min = Math.floor(option.minWaterRateSetting);
        configDouble.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxWaterRateSetting);
      } else {
        configDouble.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinFlowRate);
        configDouble.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxFlowRate);
      }

      if (option.maxWaterLevelSetting && option.minWaterLevelSetting) {
        configDouble.options.scales.yAxes[1].ticks.min = Math.floor(option.minWaterLevelSetting);
        configDouble.options.scales.yAxes[1].ticks.max = Math.ceil(option.maxWaterLevelSetting);
      } else {
        configDouble.options.scales.yAxes[1].ticks.min = Math.floor(adjustedMinWaterLevel);
        configDouble.options.scales.yAxes[1].ticks.max = Math.ceil(adjustedMaxWaterLevel);
      }

      if(option.minVelocitySetting && option.maxVelocitySetting) {
        configDouble.options.scales.yAxes[2].ticks.min = Math.floor(option.minVelocitySetting);
        configDouble.options.scales.yAxes[2].ticks.max = Math.ceil(option.maxVelocitySetting);
      } else {
        configDouble.options.scales.yAxes[2].ticks.min = Math.floor(adjustedMinVelocity);
        configDouble.options.scales.yAxes[2].ticks.max = Math.ceil(adjustedMaxVelocity);
      }
      applyYAxisRanges(
        [adjustedMinFlowRate, adjustedMaxFlowRate],
        [adjustedMinWaterLevel, adjustedMaxWaterLevel],
        [adjustedMinVelocity, adjustedMaxVelocity],
      );

    } catch (error) {
      toasting({ children: 'Start date and end date invalid!', containerProps: { className: 'border-red-600' } });
      console.error(error);
    }

    setTrigger((current) => !current);
  };

  const getDay = async (startDate:Date|null) => {
    // validate
    const deviceId = eSelectDeviceName?.current?.value;
    if (!deviceId) return;

    // Use the selected range as one continuous hourly timeline. The end is exclusive,
    // so 8/18 00:00 - 8/20 00:00 contains all hours on 8/18 and 8/19.
    const startDay = startDate ? new Date(startDate.getTime()) : new Date();
    startDay.setMinutes(0, 0, 0);
    const selectedEnd = endDateCsv && endDateCsv.getTime() > startDay.getTime()
      ? new Date(endDateCsv.getTime())
      : new Date(startDay.getTime() + 24 * 60 * 60 * 1000);
    const totalHours = Math.max(1, Math.ceil((selectedEnd.getTime() - startDay.getTime()) / (60 * 60 * 1000)));
    dataDouble.labels = Array.from({length: totalHours}, (_, index) => {
      const pointDate = new Date(startDay.getTime() + index * 60 * 60 * 1000);
      return format(pointDate, 'MM/dd HH:00');
    });

    try {
      // get records
      const query = {
        query: {
          ExpressionAttributeValues: {
            ':id': { S: deviceId },
            ':timeStart': { S: startDay.getTime().toString() },
            ':timeEnd': { S: (selectedEnd.getTime() - 1).toString() },
          },
          KeyConditionExpression: 'DEVICE_ID = :id and CREATE_AT BETWEEN :timeStart and :timeEnd',
          TableName: 'DEVICE_RECORD_DAY',
          ScanIndexForward: false,
        },
      };
      const data = await fpost<any>('api/device/record/query', {
        body: query,
      });
      const items = data[1].Items.reverse();

      resetGraphData(totalHours);

      let maxWaterLevel = -Infinity;
      let maxFlowRate = -Infinity;
      let maxVelocity = -Infinity;
      let minWaterLevel = Infinity;
      let minFlowRate = Infinity;
      let minVelocity = Infinity;
      for (const item of items) {
        const itemTime = new Date(parseInt(item.CREATE_AT?.S)).getTime();
        const idx = Math.floor((itemTime - startDay.getTime()) / (60 * 60 * 1000));
        if (idx < 0 || idx >= totalHours) continue;
        if (item.WATER_LEVEL) {
          const waterLevel = item.WATER_LEVEL.S;
          dataDouble.datasets[1].data[idx] = waterLevel;

          maxWaterLevel = Math.max(waterLevel, maxWaterLevel);
          minWaterLevel = Math.min(waterLevel, minWaterLevel);
        }
        if (item.FLOW_RATE) {
          const flowRate = item.FLOW_RATE.S;
          dataDouble.datasets[0].data[idx] = flowRate;

          maxFlowRate = Math.max(flowRate, maxFlowRate);
          minFlowRate = Math.min(flowRate, minFlowRate);
        }
        if (item.VELOCITY) {
          const velocity = item.VELOCITY.S;
          dataDouble.datasets[2].data[idx] = velocity;
          dataVelocity.datasets[0].data[idx] = velocity;

          maxVelocity = Math.max(maxVelocity, velocity);
          minVelocity = Math.min(minVelocity, velocity);
        }
      }

      const [adjustedMinWaterLevel, adjustedMaxWaterLevel] = getAdjustedValue(minWaterLevel, maxWaterLevel);
      const [adjustedMinFlowRate, adjustedMaxFlowRate] = getAdjustedValue(minFlowRate, maxFlowRate);
      const [adjustedMinVelocity, adjustedMaxVelocity] = getAdjustedValue(minVelocity, maxVelocity);

      if (option.minWaterRateSetting && option.maxWaterRateSetting) {
        configDouble.options.scales.yAxes[0].ticks.min = Math.floor(option.minWaterRateSetting);
        configDouble.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxWaterRateSetting);
      } else {
        configDouble.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinFlowRate);
        configDouble.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxFlowRate);
      }

      if (option.maxWaterLevelSetting && option.minWaterLevelSetting) {
        configDouble.options.scales.yAxes[1].ticks.min = Math.floor(option.minWaterLevelSetting);
        configDouble.options.scales.yAxes[1].ticks.max = Math.ceil(option.maxWaterLevelSetting);
      } else {
        configDouble.options.scales.yAxes[1].ticks.min = Math.floor(adjustedMinWaterLevel);
        configDouble.options.scales.yAxes[1].ticks.max = Math.ceil(adjustedMaxWaterLevel);
      }

      if(option.minVelocitySetting && option.maxVelocitySetting) {
        configDouble.options.scales.yAxes[2].ticks.min = Math.floor(option.minVelocitySetting);
        configDouble.options.scales.yAxes[2].ticks.max = Math.ceil(option.maxVelocitySetting);
      } else {
        configDouble.options.scales.yAxes[2].ticks.min = Math.floor(adjustedMinVelocity);
        configDouble.options.scales.yAxes[2].ticks.max = Math.ceil(adjustedMaxVelocity);
      }
      applyYAxisRanges(
        [adjustedMinFlowRate, adjustedMaxFlowRate],
        [adjustedMinWaterLevel, adjustedMaxWaterLevel],
        [adjustedMinVelocity, adjustedMaxVelocity],
      );

    } catch (error) {
      toasting({ children: 'Start date and end date invalid!', containerProps: { className: 'border-red-600' } });
      console.error(error);
    }

    setTrigger((current) => !current);
  };

  const getHour = async (startDate:Date|null) => {
    // validate
    const deviceId = eSelectDeviceName?.current?.value;
    if (!deviceId) return;

    // Use the full selected range without rounding records into fixed time buckets.
    const startDay = startDate ? new Date(startDate.getTime()) : new Date();
    startDay.setSeconds(0, 0);
    const endDay = endDateCsv && endDateCsv.getTime() > startDay.getTime()
      ? new Date(endDateCsv.getTime())
      : new Date(startDay.getTime() + 60 * 60 * 1000);

    try {
      // get records
      const query = {
        query: {
          ExpressionAttributeValues: {
            ':id': { S: deviceId },
            ':timeEnd': { S: (endDay.getTime() - 1).toString() },
            ':timeStart': { S: startDay.getTime().toString() },
          },
          KeyConditionExpression: 'DEVICE_ID = :id and CREATE_AT BETWEEN :timeStart and :timeEnd',
          TableName: 'DEVICE_RECORD',
          ScanIndexForward: false,
        },
      };
      const data = await fpost<any>('api/device/record/query', {
        body: query,
      });
      const items = [...(data[1].Items || [])]
        .filter((item) => Number.isFinite(Number(item.CREATE_AT?.S)))
        .sort((left, right) => Number(left.CREATE_AT.S) - Number(right.CREATE_AT.S));
      const datesInRange = new Set(
        items.map((item) => format(new Date(Number(item.CREATE_AT.S)), 'yyyy-MM-dd')),
      );
      const hourLabelFormat = datesInRange.size <= 1 ? 'HH:mm:ss' : 'MM/dd HH:mm:ss';
      const labels = items.map((item) => format(new Date(Number(item.CREATE_AT.S)), hourLabelFormat));
      dataDouble.labels = labels;
      dataFlowRate.labels = labels;
      dataWater.labels = labels;

      resetGraphData(items.length);
      let maxWaterLevel = -Infinity;
      let maxFlowRate = -Infinity;
      let maxVelocity = -Infinity;
      let minWaterLevel = Infinity;
      let minFlowRate = Infinity;
      let minVelocity = Infinity;
      items.forEach((item, idx) => {
        if (item.WATER_LEVEL) {
          const waterLevel = item.WATER_LEVEL.S;
          dataDouble.datasets[1].data[idx] = waterLevel;
          dataWater.datasets[0].data[idx] = waterLevel;

          maxWaterLevel = Math.max(maxWaterLevel, waterLevel);
          minWaterLevel = Math.min(waterLevel, minWaterLevel);
        }

        if (item.FLOW_RATE) {
          const flowRate = item.FLOW_RATE.S;
          dataDouble.datasets[0].data[idx] = flowRate;
          dataFlowRate.datasets[0].data[idx] = flowRate;

          maxFlowRate = Math.max(maxFlowRate, flowRate);
          minFlowRate = Math.min(flowRate, minFlowRate);
        }

        if (item.VELOCITY) {
          const velocity = item.VELOCITY.S;
          dataDouble.datasets[2].data[idx] = velocity;
          dataVelocity.datasets[0].data[idx] = velocity;

          maxVelocity = Math.max(maxVelocity, velocity);
          minVelocity = Math.min(minVelocity, velocity);
        }
      });
      const [adjustedMinWaterLevel, adjustedMaxWaterLevel] = getAdjustedValue(minWaterLevel, maxWaterLevel);
      const [adjustedMinFlowRate, adjustedMaxFlowRate] = getAdjustedValue(minFlowRate, maxFlowRate);
      const [adjustedMinVelocity, adjustedMaxVelocity] = getAdjustedValue(minVelocity, maxVelocity);

      if (option.minWaterRateSetting && option.maxWaterRateSetting) {
        configDouble.options.scales.yAxes[0].ticks.min = Math.floor(option.minWaterRateSetting);
        configDouble.options.scales.yAxes[0].ticks.max = Math.ceil(option.maxWaterRateSetting);
      } else {
        configDouble.options.scales.yAxes[0].ticks.min = Math.floor(adjustedMinFlowRate);
        configDouble.options.scales.yAxes[0].ticks.max = Math.ceil(adjustedMaxFlowRate);
      }

      if (option.maxWaterLevelSetting && option.minWaterLevelSetting) {
        configDouble.options.scales.yAxes[1].ticks.min = Math.floor(option.minWaterLevelSetting);
        configDouble.options.scales.yAxes[1].ticks.max = Math.ceil(option.maxWaterLevelSetting);
      } else {
        configDouble.options.scales.yAxes[1].ticks.min = Math.floor(adjustedMinWaterLevel);
        configDouble.options.scales.yAxes[1].ticks.max = Math.ceil(adjustedMaxWaterLevel);
      }

      if(option.minVelocitySetting && option.maxVelocitySetting) {
        configDouble.options.scales.yAxes[2].ticks.min = Math.floor(option.minVelocitySetting);
        configDouble.options.scales.yAxes[2].ticks.max = Math.ceil(option.maxVelocitySetting);
      } else {
        configDouble.options.scales.yAxes[2].ticks.min = Math.floor(adjustedMinVelocity);
        configDouble.options.scales.yAxes[2].ticks.max = Math.ceil(adjustedMaxVelocity);
      }
      applyYAxisRanges(
        [adjustedMinFlowRate, adjustedMaxFlowRate],
        [adjustedMinWaterLevel, adjustedMaxWaterLevel],
        [adjustedMinVelocity, adjustedMaxVelocity],
      );
    } catch (error) {
      toasting({ children: 'Start date and end date invalid!', containerProps: { className: 'border-red-600' } });
      console.error(error);
    }

    setTrigger((current) => !current);
  }

  const handleReload = async (active: number) => {
    setIsReloading(true);
    setChartLabelString(active)
    switch (active) {
      case 1:
        await getYear(startDateCsv);
        break;
      case 2:
        await getMonth(startDateCsv);
        break;
      case 3:
        await getWeek(startDateCsv);
        break;
      case 4:
        await getDay(startDateCsv);
        break;
      case 5:
        await getHour(startDateCsv);
        break;
      default:
        break;
    }
    setIsReloading(false);
  };


  const getRecord = async (page = 1) => {
    if(isRangeInvalid) {
      return
    }
    if (Boolean(startDateCsv) !== Boolean(endDateCsv)) {
      setIsRangeInvalid(true);
      toasting({ children: '開始日時と終了日時を選択してください', containerProps: { className: 'border-red-600' } });
      return;
    }
    if (startDateCsv && endDateCsv) {
      firstDayCsv = new Date(startDateCsv);
      lastDayCsv = new Date(endDateCsv);
    } else {
      date = new Date();
      firstDayCsv = new Date(date.getFullYear(), date.getMonth(), 1);
      lastDayCsv = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59);
    }
    const deviceId = eSelectDeviceName?.current?.value;

    if (!deviceId) {
      return;
    }
    
    const query = {
      query: {
        TableName: 'DEVICE_RECORD',
        KeyConditionExpression: 'DEVICE_ID = :id AND PUBLISH_FORMATED BETWEEN :timeStart AND :timeEnd',
        ExpressionAttributeValues: {
          ':id': { S: deviceId },
          ':timeStart': { S: format(firstDayCsv, 'yyyy/MM/dd HH:mm:ss') },
          ':timeEnd': { S: format(lastDayCsv, 'yyyy/MM/dd HH:mm:ss') },
        },
        Limit: page * 100,
        Select:"ALL_ATTRIBUTES",
        IndexName: 'DEVICE_ID-PUBLISH_FORMATED-index',
        ReturnConsumedCapacity: "TOTAL",
        ScanIndexForward: false,
      }
    };


    let extraData = null;
    if (deviceId === 'DEVICE_1721980272836') {
      const extraQuery = {
        query: {
          TableName: 'DEVICE_RECORD',
          KeyConditionExpression: 'DEVICE_ID = :id AND PUBLISH_FORMATED BETWEEN :timeStart AND :timeEnd',
          ExpressionAttributeValues: {
            ':id': { S: deviceId },
            ':timeStart': { S: format(firstDayCsv, 'yyyy/M/dd HH:mm:ss') },
            ':timeEnd': { S: format(lastDayCsv, 'yyyy/M/dd HH:mm:ss') },
          },
          Limit: page * 100,
          Select:"ALL_ATTRIBUTES",
          IndexName: 'DEVICE_ID-PUBLISH_FORMATED-index',
          ReturnConsumedCapacity: "TOTAL",
          ScanIndexForward: false,
        }
      };

      extraData = await fpost<any, ResponseListDocuments<DeviceRecord>>('api/device/record/query', {
        body: extraQuery,
      });
    }
    
    let data;
    try {
      data = await fpost<any, ResponseListDocuments<DeviceRecord>>('api/device/record/query', {
        body: query,
      });

      if(extraData){
        const mergedItems = [...(data[1].Items || []), ...(extraData[1].Items || [])];
        data[1].Items = mergedItems;
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      toasting({ children: 'Failed to fetch data. Please check the query.', containerProps: { className: 'border-red-600' } });
      return;
    }

    setRecord(data[1]);
  };

  const getRecordClick = async () => {
    setGetRecordProcessing(true);
    await getRecord();
    setGetRecordProcessing(false);
  };

  const getRecordCsv = async () => {
    setDownloadCsvProcessing(true);
    if (Boolean(startDateCsv) !== Boolean(endDateCsv)) {
      setIsRangeInvalid(true);
      setDownloadCsvProcessing(false);
      toasting({ children: '開始日時と終了日時を選択してください', containerProps: { className: 'border-red-600' } });
      return;
    }
    if (startDateCsv && endDateCsv) {
      firstDayCsv = new Date(startDateCsv);
      lastDayCsv = new Date(endDateCsv);
    } else {
      date = new Date();
      firstDayCsv = new Date(date.getFullYear(), date.getMonth(), 1);
      lastDayCsv = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59);
    }
    const deviceId = eSelectDeviceName?.current?.value;
    if (!deviceId) {
      return;
    }

    const query = {
      query: {
        TableName: 'DEVICE_RECORD',
        KeyConditionExpression: 'DEVICE_ID = :id AND PUBLISH_FORMATED BETWEEN :timeStart AND :timeEnd',
        ExpressionAttributeValues: {
          ':id': { S: deviceId },
          ':timeStart': { S: format(firstDayCsv, 'yyyy/MM/dd HH:mm:ss') },
          ':timeEnd': { S: format(lastDayCsv, 'yyyy/MM/dd HH:mm:ss') },
        },
        Select:"ALL_ATTRIBUTES",
        IndexName: 'DEVICE_ID-PUBLISH_FORMATED-index',
        ReturnConsumedCapacity: "TOTAL",
        ScanIndexForward: false,
      }
    };

    let extraData = null;
    if (deviceId === 'DEVICE_1721980272836') {
      const extraQuery = {
        query: {
          TableName: 'DEVICE_RECORD',
          KeyConditionExpression: 'DEVICE_ID = :id AND PUBLISH_FORMATED BETWEEN :timeStart AND :timeEnd',
          ExpressionAttributeValues: {
            ':id': { S: deviceId },
            ':timeStart': { S: format(firstDayCsv, 'yyyy/M/dd HH:mm:ss') },
            ':timeEnd': { S: format(lastDayCsv, 'yyyy/M/dd HH:mm:ss') },
          },
          Select:"ALL_ATTRIBUTES",
          IndexName: 'DEVICE_ID-PUBLISH_FORMATED-index',
          ReturnConsumedCapacity: "TOTAL",
          ScanIndexForward: false,
        }
      };

      extraData = await fpost<any, ResponseListDocuments<DeviceRecord>>('api/device/record/query', {
        body: extraQuery,
      });
    }
    
    const data = await fpost<any, ResponseListDocuments<DeviceRecord>>('api/device/record/query', {
      body: query,
    });

    if(extraData){
      const mergedItems = [...(data[1].Items || []), ...(extraData[1].Items || [])];
      data[1].Items = mergedItems;
    }

    const items = data[1].Items;
    const records: any[] = [];
    items?.forEach((it: any) => {
      records.push([
        it.SID?.S,
        it.CNT?.S,
        it.RF?.S,
        it.VOL?.S,
        it.DIS?.S,
        it.Publish?.S,
        it.WATER_LEVEL?.S,
        it.VELOCITY?.S,
        it.FLOW_RATE?.S,
      ]);
    });
    setCsvData(records);

    setDownloadCsvProcessing(false);
    if (!records.length) {
      toasting({ children: 'データがありません', containerProps: { className: 'border-blue-600' } });
    }
  };

  useEffect(() => {
    if (csvData.length > 0) {
      csvLinkRef.current.link.click();
    }
  }, [csvData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const areaResponse = await fget<unknown, ResponseListDocuments<AreaEntity>>('api/areas');

        const areaName = areaResponse[1].Items?.[0].AREA_NAME?.S;
        let requestedDevice: ResponseGetDocument<DeviceEntity>['Item'] | undefined;

        if (id) {
          const res = await fget<unknown, ResponseGetDocument<DeviceEntity>>(`api/devices/${id}`);
          requestedDevice = res[1].Item;
        }

        const newAreaName = requestedDevice?.AREA_NAME?.S || areaName;

        const devicesResponse = await fget<unknown, ResponseListDocuments<DeviceEntity>>(
          `api/deviceByArea?AREA_NAME=${encodeURIComponent(newAreaName || '')}`,
        );
        const areaDevices = devicesResponse[1].Items || [];
        const requestedAreaDevice = id ? areaDevices.find((item) => item.DEVICE_ID?.S === id) : undefined;
        const activeDevice = areaDevices.find((item) => item.DEVICE_STATUS?.S !== 'INACTIVE');
        const device = requestedAreaDevice || activeDevice || areaDevices[0];

        setData({
          areas: areaResponse[1],
          devices: devicesResponse[1],
          deviceInit: device,
        });
        setSelectedAreaName(newAreaName || '');
        setSelectedDeviceId(device?.DEVICE_ID?.S || '');
      } catch (error) {
        // Handle errors here
        toasting({ children: '認証に失敗しました', containerProps: { className: 'border-red-600' } });
        console.error(error);
      }
    };

    fetchData();
  }, [id]);

  useEffect( () => {
    const reload = async () => {
      if (!selectedDeviceId || !startDateCsv) return;

      switch (active) {
        case 1:
          await getYear(startDateCsv);
          break;
        case 2:
          await getMonth(startDateCsv);
          break;
        case 3:
          await getWeek(startDateCsv);
          break;
        case 4:
          await getDay(startDateCsv);
          break;
        case 5:
          await getHour(startDateCsv);
          break;
        default:
          break;
      }
    }
    setChartLabelString(active)
    reload()
  }, [
    selectedDeviceId,
    startDateCsv,
    endDateCsv,
  ]);

  const selectedDevice = data?.devices?.Items?.find((device) => device.DEVICE_ID?.S === selectedDeviceId);

  const getSelectedMetric = (datasetIndex: number) => {
    if (selectedPointIndex === null) return '--';

    const rawValue = dataDouble.datasets[datasetIndex]?.data?.[selectedPointIndex];
    const value = Number(rawValue);
    if (rawValue !== null && rawValue !== undefined && Number.isFinite(value)) return value.toFixed(2);
    return '--';
  };

  const handleChartPointClick = (elements: any[]) => {
    const pointIndex = elements?.[0]?._index;
    if (typeof pointIndex === 'number') setSelectedPointIndex(pointIndex);
  };

  const selectedRangeLabel = String(configDouble.options.scales.xAxes[0].scaleLabel.labelString)
    .trim()
    .replace(/\s+/g, ' ');
  const selectedPointLabel = selectedPointIndex === null
    ? 'グラフの点を選択してください'
    : String(dataDouble.labels[selectedPointIndex]);

  const rawChartData = useMemo(() => ({
    labels: dataDouble.labels,
    datasets: dataDouble.datasets.map((dataset) => ({
      ...dataset,
      fill: false,
      spanGaps: true,
      lineTension: 0,
      pointRadius: 0,
      pointHoverRadius: 4,
      pointHitRadius: 12,
      pointBorderWidth: 0,
      pointHoverBorderWidth: 0,
      pointBorderColor: dataset.borderColor,
      pointBackgroundColor: dataset.borderColor,
      pointHoverBorderColor: dataset.borderColor,
      pointHoverBackgroundColor: dataset.borderColor,
    })),
  }), [trigger]);

  const rawChartOptions = useMemo(() => {
    const manualRanges = [
      [minWaterRateSetting, maxWaterRateSetting],
      [minWaterLevelSetting, maxWaterLevelSetting],
      [minVelocitySetting, maxVelocitySetting],
    ];

    return {
      ...configDouble.options,
      scales: {
        ...configDouble.options.scales,
        xAxes: configDouble.options.scales.xAxes.map((axis) => ({
          ...axis,
          ticks: {...axis.ticks},
          scaleLabel: {...axis.scaleLabel},
        })),
        yAxes: configDouble.options.scales.yAxes.map((axis, axisIndex) => {
          const [manualMin, manualMax] = manualRanges[axisIndex];
          const hasManualMin = manualMin !== null && Number.isFinite(Number(manualMin));
          const hasManualMax = manualMax !== null && Number.isFinite(Number(manualMax));

          return {
            ...axis,
            scaleLabel: {...axis.scaleLabel},
            ticks: {
              ...axis.ticks,
              min: hasManualMin ? Number(manualMin) : axis.ticks.min,
              max: hasManualMax ? Number(manualMax) : axis.ticks.max,
            },
          };
        }),
      },
    };
  }, [
    trigger,
    minWaterRateSetting,
    maxWaterRateSetting,
    minWaterLevelSetting,
    maxWaterLevelSetting,
    minVelocitySetting,
    maxVelocitySetting,
  ]);

  return (
    <div className="raw-page">
      <header className="raw-page-header">
        <div>
          <p className="raw-page-eyebrow">生データ表示</p>
          <h1>{selectedDevice?.DEVICE_NAME?.S || 'デバイスを選択'}</h1>
          <p className="raw-page-meta">
            {[selectedAreaName, selectedDeviceId].filter(Boolean).join(' ・ ')}
          </p>
        </div>
        {selectedDevice && (
          <span className={`raw-status ${selectedDevice.DEVICE_STATUS?.S === 'INACTIVE' ? 'is-inactive' : ''}`}>
            {selectedDevice.DEVICE_STATUS?.S === 'INACTIVE' ? '非アクティブ' : 'アクティブ'}
          </span>
        )}
      </header>

      <div className="raw-main-grid">
        <div className="raw-control-column">
        <section className="raw-card raw-filter-card">
        <div className="raw-filter-grid">
          {data?.deviceInit && (
            <Select
              onChange={(e) => {
                const areaName = e.target.value;
                setSelectedAreaName(areaName);
                fget<unknown, ResponseListDocuments<DeviceEntity>>(
                  `api/deviceByArea?AREA_NAME=${encodeURIComponent(areaName)}`,
                  {},
                ).then((devices) => {
                  const areaDevices = devices[1]?.Items || [];
                  const firstDevice = areaDevices.find((device) => device.DEVICE_STATUS?.S !== 'INACTIVE') || areaDevices[0];
                  setData((prev) => ({
                    ...prev,
                    devices: devices[1],
                    deviceInit: firstDevice,
                  }));
                  setSelectedDeviceId(firstDevice?.DEVICE_ID?.S || '');
                });
              }}
              value={selectedAreaName}
              labelProps={{value: '地域名'}}
              containerProps={{className: 'raw-select'}}
              required
              ref={eSelectRegionName}>
              {data?.areas?.Items?.map((region, i) => (
                <option key={`Option-` + i} value={region.AREA_NAME?.S}>
                  {region.AREA_NAME?.S}
                </option>
              ))}
            </Select>
          )}

          {data?.deviceInit && (
            <Select
              key={selectedAreaName}
              value={selectedDeviceId}
              onChange={(e) => setSelectedDeviceId(e.target.value)}
              labelProps={{value: 'デバイス名'}}
              containerProps={{className: 'raw-select'}}
              required
              ref={eSelectDeviceName}>
              {data?.devices?.Items?.map((device, i) => (
                <option key={`Option-` + i} value={device.DEVICE_ID?.S}>
                  {device.DEVICE_NAME?.S}
                  {device.DEVICE_STATUS?.S === 'INACTIVE' ? '（非アクティブ）' : ''}
                </option>
              ))}
            </Select>
          )}

          <label className="raw-date-field">
            <span>表示期間</span>
            <DatePicker
              selectsRange
              className={isRangeInvalid ? 'is-invalid' : ''}
              selected={endDateCsv || startDateCsv}
              startDate={startDateCsv}
              endDate={endDateCsv}
              onChange={(update: [Date | null, Date | null] | Date | null) => {
                if (Array.isArray(update)) {
                  setDateRange(update);
                } else if (update instanceof Date) {
                  setDateRange(([currentStart, currentEnd]) => {
                    const dateToKeep = currentEnd || currentStart;
                    if (!dateToKeep) return [update, null];

                    // react-datepicker 4.x returns only a time value here and bases
                    // its date on today. Keep the already selected calendar date and
                    // copy only the chosen time onto it.
                    const dateWithUpdatedTime = new Date(dateToKeep.getTime());
                    dateWithUpdatedTime.setHours(update.getHours(), update.getMinutes(), update.getSeconds(), 0);
                    return currentEnd
                      ? [currentStart, dateWithUpdatedTime]
                      : [dateWithUpdatedTime, null];
                  });
                } else {
                  setDateRange([null, null]);
                }
                setIsRangeInvalid(false);
              }}
              showTimeSelect
              locale={ja}
              timeFormat="HH:mm"
              timeIntervals={60}
              dateFormat="yyyy/MM/dd HH:mm"
              placeholderText="開始日時 - 終了日時"
              isClearable
            />
            <small>グラフは開始日時を基準に表示します</small>
          </label>
        </div>

        <div className="raw-actions">
          <Button onClick={getRecordClick} className="raw-primary-button" isProcessing={getRecordProcessing}>
            生データを確認
          </Button>
          <Button className="raw-secondary-button" onClick={getRecordCsv} isProcessing={downloadCsvProcessing}>
            CSVダウンロード
          </Button>
          <CSVLink ref={csvLinkRef} asyncOnClick data={csvData} headers={headers} filename="Raw_data.csv" />
        </div>
        </section>

        </div>

        <section className="raw-card raw-chart-card">
        <div className="raw-section-heading">
          <div>
            <p className="raw-section-kicker">計測推移</p>
            <h2>グラフ</h2>
          </div>
          <div className="raw-chart-controls">
            <div className="raw-period-tabs">
              {[
                [1, '年'],
                [2, '月'],
                [3, '週'],
                [4, '日'],
                [5, '時'],
              ].map(([period, label]) => (
                <button
                  key={period}
                  type="button"
                  onClick={() => {
                    const nextPeriod = Number(period);
                    setActive(nextPeriod);
                    setChartLabelString(nextPeriod);
                    handleReload(nextPeriod);
                  }}
                  className={active === Number(period) ? 'is-active' : ''}>
                  {label}
                </button>
              ))}
            </div>
            <button className="raw-reload-button" type="button" onClick={() => handleReload(active)} title="再読み込み">
              <AiOutlineReload
                className={twMerge(isReloading ? 'animate-spin' : 'animate-none')}
                strokeWidth={20}
                size={22}
              />
              再読み込み
            </button>
          </div>
        </div>

        <div className="raw-axis-editor">
          {[
            {label: '流量', minId: 'minFlowRate', maxId: 'maxFlowRate', minKey: 'minWaterRateSetting', maxKey: 'maxWaterRateSetting', minValue: minWaterRateSetting, maxValue: maxWaterRateSetting},
            {label: '水位', minId: 'minWaterLevel', maxId: 'maxWaterLevel', minKey: 'minWaterLevelSetting', maxKey: 'maxWaterLevelSetting', minValue: minWaterLevelSetting, maxValue: maxWaterLevelSetting},
            {label: '流速', minId: 'minVelocity', maxId: 'maxVelocity', minKey: 'minVelocitySetting', maxKey: 'maxVelocitySetting', minValue: minVelocitySetting, maxValue: maxVelocitySetting},
          ].map(({label, minId, maxId, minKey, maxKey, minValue, maxValue}) => (
            <div className="raw-axis-row" key={label}>
              <span>{label}</span>
              <input type="number" id={minId} placeholder="Min" value={minValue ?? ''} onChange={(e) => handleMinMax(e, minKey)} />
              <span>–</span>
              <input type="number" id={maxId} placeholder="Max" value={maxValue ?? ''} onChange={(e) => handleMinMax(e, maxKey)} />
            </div>
          ))}
          <button type="button" className="raw-axis-reset" onClick={resetSettingMinMaxData}>軸設定をリセット</button>
        </div>

        <div className="raw-chart-canvas">
          <Line data={rawChartData} options={rawChartOptions} onElementsClick={handleChartPointClick}/>
        </div>
        </section>

        <section className="raw-kpi-grid" aria-label="選択した地点の値">
          <div className={`raw-selected-point ${selectedPointIndex === null ? 'is-empty' : ''}`}>
            <span>選択した点</span>
            {selectedPointIndex !== null && <span className="raw-selected-range">{selectedRangeLabel}</span>}
            <strong>{selectedPointLabel}</strong>
          </div>
          <article className="raw-kpi-card is-blue">
            <span>流量</span>
            <div><strong>{getSelectedMetric(0)}</strong><small>m³/s</small></div>
          </article>
          <article className="raw-kpi-card is-red">
            <span>水位</span>
            <div><strong>{getSelectedMetric(1)}</strong><small>m</small></div>
          </article>
          <article className="raw-kpi-card is-green">
            <span>流速</span>
            <div><strong>{getSelectedMetric(2)}</strong><small>m/s</small></div>
          </article>
        </section>
      </div>

      <section className="raw-card raw-table-card">
        <div className="raw-section-heading raw-table-heading">
          <div>
            <p className="raw-section-kicker">取得データ</p>
            <h2>生データ一覧</h2>
          </div>
          <span className="raw-total">Total: {record?.Items?.length || 0}</span>
        </div>
        <Pagination
          total={10000000}
          onPageChange={(page) => {
            if (!record?.Items?.length) {
              getRecord(1);
            } else {
              getRecord(page + 1);
            }
          }}
          hidePages
        />

        <div className="raw-table-scroll">
        <Table
        hideCheckbox
        headCellData={[
          'No',
          'GID',
          'SID',
          'CNT',
          'POS',
          'RF',
          'VOL',
          'DIS',
          'Publish',
          'WATER_LEVEL',
          'VELOCITY',
          'FLOW_RATE',
          "Frq_AS",
          "Frq_A4",
          "Frq_A5",
          "VOL_A3",
          "TEMP",
          "EULER",
          "BNO_CAL",
          "VOL_BAT",
          "PWR_SOL",
        ]}
        id="table-flow"
        cellData={record?.Items?.map((it, i) => [
          i + 1,
          it.GID?.S,
          it.SID?.S,
          it.CNT?.S,
          it.POS?.S,
          it.RF?.S,
          it.VOL?.S,
          it.DIS?.S,
          it.PUBLISH_FORMATED?.S,
          it.WATER_LEVEL?.S ? parseFloat(it.WATER_LEVEL.S).toFixed(4) : '',
          it.VELOCITY?.S ? parseFloat(it.VELOCITY.S).toFixed(4) : '',
          it.FLOW_RATE?.S ? parseFloat(it.FLOW_RATE.S).toFixed(4) : '',
          it.Frq_AS?.S,
          it.Frq_A4?.S,
          it.Frq_A5?.S,
          it.VOL_A3?.S,
          it.TEMP?.S,
          it.EULER?.S,
          it.BNO_CAL?.S,
          it.VOL_BAT?.S,
          it.PWR_SOL?.S,
        ])}
        />
        </div>
      </section>
    </div>
  );
}
